import React from "react";
import { Box, Typography, Chip, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import type { StepDiagnostics } from "./types";
import { DiagnosticCountChips } from "./DiagnosticCountChips";
import { DiagnosticEventsDisplay } from "./DiagnosticEventsDisplay";

interface StepAccordionProps {
  title: string;
  diagnostics?: StepDiagnostics;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

export function StepAccordion({
  title,
  diagnostics,
  defaultExpanded,
  children,
}: StepAccordionProps) {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
          <Typography>{title}</Typography>
          {diagnostics && (
            <>
              <Chip
                size="small"
                label={diagnostics.success ? "Success" : "Failed"}
                color={diagnostics.success ? "success" : "error"}
              />
              {diagnostics.durationMs && (
                <Typography variant="caption" color="text.secondary">
                  {diagnostics.durationMs}ms
                </Typography>
              )}
            </>
          )}
          <Box sx={{ ml: "auto", mr: 1 }}>
            <DiagnosticCountChips events={diagnostics?.diagnosticEvents} />
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {children}
        {diagnostics?.diagnosticEvents && diagnostics.diagnosticEvents.events.length > 0 && (
          <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: "divider" }}>
            <DiagnosticEventsDisplay events={diagnostics.diagnosticEvents} title="Step Logs" />
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
